// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1OUVO","label":"Section_label__anVaV","contentWrap":"Section_contentWrap__2YjtC","footer":"Section_footer__3-ZEy","footerInner":"Section_footerInner__2sqI6"};